import { Box, Flex, Skeleton, SkeletonText, VStack } from '@chakra-ui/react';
import React from 'react';

type PriceSummaryPanelSkeletonProps = object;

export const PriceSummaryPanelSkeleton: React.FC<PriceSummaryPanelSkeletonProps> = () => (
  <>
    <VStack gap={5}>
      <SkeletonText noOfLines={1} width="120px" />
      <VStack gap={4} align="stretch" pl={3} w="full">
        <Flex justifyContent="space-evenly" w="full">
          <SkeletonText noOfLines={1} width="120px" />
          <Box textAlign="right">
            <SkeletonText noOfLines={1} width="60px" textAlign="right" />
          </Box>
        </Flex>
        <Box>
          <Flex justifyContent="space-evenly" w="full">
            <SkeletonText noOfLines={1} width="160px" />
            <Box textAlign="right">
              <SkeletonText noOfLines={1} width="50px" textAlign="right" />
            </Box>
          </Flex>
          <Skeleton height="80px" width="100%" rounded="lg" mt={2} />
        </Box>
      </VStack>
      <Flex justifyContent="space-evenly" w="full">
        <SkeletonText noOfLines={1} width="160px" />
        <Box textAlign="right">
          <SkeletonText noOfLines={1} width="60px" textAlign="right" />
        </Box>
      </Flex>
    </VStack>
    <Skeleton height="40px" width="100%" rounded="lg" mt={5} />
  </>
);
